import { styled } from '@mui/material';
import ReactInputVerificationCode from "react-input-verification-code";

export const CodeAuth = styled(ReactInputVerificationCode)(({ theme }) => (props) => ({
}))
